<template>
  <wizard
    first-step="info"
    class="wizard-no-child-benefits"
  >
    <wizard-step
      :i18n="i18n"
      name="info"
      :model="formData"
    >
      <wizard-step-intro>
        <h2>{{ i18n.wizardSteps.info.title }}</h2>
        <slot />
      </wizard-step-intro>
    </wizard-step>
  </wizard>
</template>

<script>
import Wizard from '@/components/wizards/components/Wizard.vue';
import WizardStep from '@/components/wizards/components/WizardStep.vue';
import WizardStepIntro from '@/components/wizards/components/WizardStepIntro.vue';
import getQueryParams from '@/lib/formulate/getFormQueryParam';

export default {
  name: 'WizardMoreDaycare',
  components: { Wizard, WizardStep, WizardStepIntro },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    prefillData: {
      type: Object,
      default: () => { },
    },
    label: {
      type: String,
      default: 'Partou',
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  created () {
    this.formData.personalDetails = {
      ...this.formData.personalDetails,
      ...getQueryParams(this.prefillData)
    }
  },
};
</script>
